import { TooltipProps } from '.';
import { createUseStyles } from 'react-jss';
import { TooltipPosition, InputTheme } from '@tcl-argon-models/models';
import { grayPalette } from '@tcl-argon-colors/colors';

const belowCenterTooltip = {
  left: '50%',
  bottom: '-10px',
  transform: 'translate(-50%, 100%)',
};

const belowRightTooltip = {
  left: 'calc(50% - 26px)',
  top: 'calc(100% + 10px)',
};

const belowLeftTooltip = {
  right: 'calc(50% - 26px)',
  top: 'calc(100% + 10px)',
};

const aboveCenterTooltip = {
  left: '50%',
  top: '-10px',
  transform: 'translate(-50%, -100%)',
};

const aboveRightTooltip = {
  left: 'calc(50% - 26px)',
  bottom: 'calc(100% + 10px)',
};

const aboveLeftTooltip = {
  right: 'calc(50% - 26px)',
  bottom: 'calc(100% + 10px)',
};

const sideLeftTooltip = {
  right: 'calc(100% + 10px)',
  top: '50%',
  transform: 'translateY(-50%)',
};

const sideRightTooltip = {
  left: 'calc(100% + 10px)',
  top: '50%',
  transform: 'translateY(-50%)',
};

const getTooltipPositionStyles = (position: TooltipPosition) => {
  switch (position) {
    case 'above-left': {
      return aboveLeftTooltip;
    }
    case 'above-center': {
      return aboveCenterTooltip;
    }
    case 'above-right': {
      return aboveRightTooltip;
    }
    case 'side-left': {
      return sideLeftTooltip;
    }
    case 'side-right': {
      return sideRightTooltip;
    }
    case 'below-left': {
      return belowLeftTooltip;
    }
    case 'below-center': {
      return belowCenterTooltip;
    }
    case 'below-right': {
      return belowRightTooltip;
    }
    default:
      return 'Unreachable!' as never;
  }
};

const tooltipThemes = {
  [InputTheme.Default]: { textColor: grayPalette.gray100, background: "white" },
  [InputTheme.Dark]: { textColor: 'white', background: grayPalette.gray90 }
}

export const useTooltipStyles = createUseStyles({
  root: {
    position: 'relative',
  },
  tooltip: ({ position, theme }: TooltipProps) => ({
    position: 'absolute',
    zIndex: 1,
    ...getTooltipPositionStyles(position),
    color: tooltipThemes[theme] ? tooltipThemes[theme].textColor : grayPalette.gray100,
    background: tooltipThemes[theme] ? tooltipThemes[theme].background : "white"
  }),
});
